import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp } from "vue";
import router from "./router";
import store from "./store";
import App from "./App.vue";
import mathjaxDirective from './directives/v-mathjax'
import { initPosthog } from './analytics/posthog'
import { initHubspot } from './analytics/hubspot'
import { initGtag } from './analytics/gtag'

import { createGtm } from "vue-gtm";

const app = createApp(App);

const isSSO = !!(store && store.getters && store.getters.isSSO)

app.use(
	createGtm({
		id: "GTM-WNX3PZT",
		enabled: !isSSO,
		loadScript: !isSSO,
		vueRouter: router
	})
);

app.use(store);
app.use(router);
app.directive('mathjax', mathjaxDirective)

// Init analytics seulement si non SSO
if (!isSSO) {
	console.info('[Analytics] Initialisation Posthog/Hubspot/Gtag (non SSO)')
	initPosthog(store)
	initHubspot(store)
	initGtag(store)
} else {
	console.info('[Analytics] Skippé car SSO')
}

app.mount("#app");
